import { Skeleton } from '@nextui-org/react-latest'

const VerticalCourseSkeleton = () => {
  return (
    <div className="min-h-[365px] flex-col space-y-4">
      <Skeleton className="h-[168px] w-full rounded-2xl">
        <div className="h-[168px] rounded-2xl bg-default-300" />
      </Skeleton>
      <div className="space-y-3 h-24 w-full">
        <Skeleton className="h-[36px] w-full rounded-md">
          <div className="h-[36px] w-full rounded-md bg-default-200" />
        </Skeleton>
        <Skeleton className="h-[18px] w-full rounded-md">
          <div className="h-[18px] w-full rounded-md bg-default-200" />
        </Skeleton>
        <div className="h-[24px] flex justify-between items-end">
          <Skeleton className="h-[22px] w-32 rounded-md">
            <div className="h-[22px] w-32 rounded-md bg-default-300" />
          </Skeleton>
          <Skeleton className="h-[22px] w-24 rounded-md">
            <div className="h-[22px] w-24 rounded-md bg-default-300" />
          </Skeleton>
        </div>
        <div className="h-[48px] flex justify-between items-end">
          <Skeleton className="h-[22px] w-24 rounded-md">
            <div className="h-[22px] w-24 rounded-md bg-default-300" />
          </Skeleton>
          <Skeleton className="h-[32px] w-24 rounded-md">
            <div className="h-[32px] w-24 rounded-md bg-default-300" />
          </Skeleton>
        </div>
      </div>
    </div>
  )
}

export default VerticalCourseSkeleton
